import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './css/ZIndex.css';
import Config from './config/Config';
import {
    HomePageWrapper,
    LoginPageWrapper,
    ContactPageWrapper,
    TermsPageWrapper,
    SellMyHomePageWrapper,
    GetValuationPageWrapper,
    SavedValuationsPageWrapper,
    ValuationPageWrapper,
    ValuationPageWithoutSlugWrapper,
    AreaSearchPageWrapper,
    AreaAnalysisPageWrapper,
    PremiumPageWrapper,
    OldUrlRedirectWrapper
} from './components/navigation/PageWrappers';
import NavigationProvider from './components/navigation/NavigationProvider';
import HomePageWithRedirect from './components/navigation/HomePageWithRedirect';
import { AppProvider } from './context/AppContext';
import type { AppDependencies } from './context/AppContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import posthog from 'posthog-js';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Instantiate app dependencies once at the root
const config = new Config();

posthog.init(config.deploymentEnvironmentConfig.get("POSTHOG_TOKEN"), {
  api_host: config.deploymentEnvironmentConfig.get("POSTHOG_HOST"),
  defaults: '2026-01-30',
});
const dependencies: AppDependencies = {
    config,
    pathRouter: config.getPathRouter(),
    apiHandler: config.getApiHandler(),
    errorHandler: config.getErrorHandler(),
    loader: config.getLoader(),
    loginHelper: config.getLoginHelper(),
    stateHandler: config.getEventAdaptingStateHandler(),
    featureProvider: config.getFeatureProvider(),
    areaAnalysisBuilderChain: config.getAreaAnalysisBuilderChain(),
};

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
    <GoogleOAuthProvider clientId="316780219697-27hs7eov4skk7hvmlmeunkvtq8m2b1p6.apps.googleusercontent.com">
    <BrowserRouter>
      <AppProvider dependencies={dependencies}>
        <NavigationProvider>
          <Routes>
        {/* Home/Search Page - handles old URL patterns */}
        <Route path="/" element={<HomePageWithRedirect />} />
        
        {/* Login Page */}
        <Route path="/login" element={<LoginPageWrapper />} />
        
        {/* Contact Page */}
        <Route path="/contact" element={<ContactPageWrapper />} />
        
        {/* Terms Page */}
        <Route path="/terms" element={<TermsPageWrapper />} />
        
        {/* Sell My Home Page */}
        <Route path="/sell-my-home" element={<SellMyHomePageWrapper />} />
        
        {/* Get Valuation Page */}
        <Route path="/get-valuation" element={<GetValuationPageWrapper />} />
        
        {/* Plans Page */}
        <Route path="/plans" element={<PremiumPageWrapper />} />

        {/* Saved Valuations Page */}
        <Route path="/saved-valuations" element={<SavedValuationsPageWrapper />} />

        {/* Area Search Page */}
        <Route path="/areas" element={<AreaSearchPageWrapper />} />

        {/* Area Analysis Pages - with and without slug */}
        <Route path="/area/:areaId/:areaSlug" element={<AreaAnalysisPageWrapper />} />
        <Route path="/area/:areaId" element={<AreaAnalysisPageWrapper />} />
        
        {/* Valuation Pages - with address slug */}
        <Route path="/valuate/:propertyId/:addressSlug" element={<ValuationPageWrapper />} />
        
        {/* Valuation Page - without address slug (fallback) */}
        <Route path="/valuate/:propertyId" element={<ValuationPageWithoutSlugWrapper />} />
        
        {/* Catch-all: handle old URL patterns with query params */}
        <Route path="*" element={<OldUrlRedirectWrapper />} />
          </Routes>
        </NavigationProvider>
      </AppProvider>
    </BrowserRouter>
    </GoogleOAuthProvider>
    </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);

